import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const nocDrawerShowSelector = createSelector(
  selector,
  store => store.visible,
);

export const nocUrlSelector = createSelector(
  selector,
  (store) => {
    const { nocUrl } = store;
    return nocUrl;
  },
);

export const nocDrawerTrendsConfigSelector = createSelector(
  selector,
  store => store.trends,
);

export const nocDrawerFiltersConfigSelector = createSelector(
  selector,
  store => store.filters,
);

export const nocDrawerTrendsFilterSelector = createSelector(
  selector,
  (state) => {
    const { filterBars, currentFilterBar } = state.trends;
    const filters = filterBars.reduce((obj, item) => ({ ...obj, ...item.filters }), {});
    return {
      selected: get(filterBars, `[${currentFilterBar}].filters`),
      filters,
    };
  },
);

export const nocDrawerFiltersFilterSelector = createSelector(
  selector,
  (state) => {
    const { filterBars, currentFilterBar } = state.filters;
    const filters = filterBars.reduce((obj, item) => ({ ...obj, ...item.filters }), {});
    return {
      selected: get(filterBars, `[${currentFilterBar}].filters`),
      filters,
    };
  },
);

export const nocDrawerFiltersDimensionSelectionModeSelector = createSelector(
  selector,
  (state) => {
    const { dimensionSelectionMode } = state.filters;
    return dimensionSelectionMode;
  },
);

export const nocDrawerFiltersCurrentFilterBar = createSelector(
  selector,
  (state) => {
    const { filterBars, currentFilterBar: currentIndex } = state.filters;
    return filterBars[currentIndex];
  },
);

export const nocDrawerTrendsCurrentFilterBar = createSelector(
  selector,
  (state) => {
    const { filterBars, currentFilterBar: currentIndex } = state.trends;
    return filterBars[currentIndex];
  },
);

export const nocDrawerTrendsFilterBarsSelector = createSelector(
  selector,
  (state) => {
    const { filterBars } = state.trends;
    return filterBars;
  },
);

export const nocDrawerFiltersFilterBarsSelector = createSelector(
  selector,
  (state) => {
    const { filterBars } = state.filters;
    return filterBars;
  },
);
